import { Trans } from '@lingui/macro'
import { DialogContentText, Typography } from '@mui/material'
import type { EnhancedDomain } from 'sunlife-domain'

import { AttributeToggleSelector, GenericDimensionSlider } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { HelpButton } from './HelpButton'

const INSEAM_MARKS = [
  { value: -0.5, label: '-0.5"' },
  { value: 0, label: 'Standard' },
  { value: 0.5, label: '+0.5"' },
]

export const ShortsProperties = (props: { entity: EnhancedDomain.$Shorts }) => {
  const { entity } = props
  return (
    <PropertyContainer.Group spacing="large">
      <PropertyContainer.Item
        title={
          <Typography>
            <Trans>Inseam</Trans>
          </Typography>
        }
        action={
          <HelpButton
            title={
              <Typography>
                <Trans>Inseam</Trans>
              </Typography>
            }
          >
            <DialogContentText>
              Our standard <b>inseam is 2.5”</b> and you may increase or decrease or your inseam in .5” increments
            </DialogContentText>
          </HelpButton>
        }
      >
        <div style={{ width: 'calc(100% - 16px)', paddingLeft: '8px' }}>
          <GenericDimensionSlider
            entityId={entity.id}
            instanceName="inseam"
            marks={INSEAM_MARKS}
            step={null}
            sliderOnly
          />
        </div>
      </PropertyContainer.Item>
      {/* Fabric and Liner selectors hidden for Helios - using default values */}
      <PropertyContainer.Item
        title={
          <Typography>
            <Trans>Size</Trans>
          </Typography>
        }
      >
        <AttributeToggleSelector entityId={entity.id} instanceName="size" columnCount={4} />
      </PropertyContainer.Item>
    </PropertyContainer.Group>
  )
}
